import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import RegisterSuccess from "../../../assets/images/tick.svg";
import { ILogin } from "../../../models/ILogin";
import { SetPasswordService } from "../../../services/Account/SetPasswordService";
import { Logindata, Logout } from "../../../utils/AccountUtils";
import { validEmail } from "../../../utils/utils";
import LocalStorageContext from "../../context/LocalStorageContext";
import styles from "../Login/Login.module.css";
import { Button, Input, Modal, Typography } from "antd";
import { AuthHero } from "../../comman/AuthHero/AuthHero";
import { invoiceRegisterHeroContent } from "../../comman/AuthHero/InvoiceRegisterHero.content";
import SocialFollow from "../../comman/SocialFollow/SocialFollow";

const { Title, Text } = Typography;

interface IState {
	user: ILogin;
}

const ForgotPassword: React.FC = () => {
	const navigate = useNavigate();
	const [state, setState] = useState<IState>({
		user: {
			userName: "",
			password: "",
			loginType: 1
		}
	});
	const [userErrorMessage, setuserErrorMessage] = React.useState("");
	const [passErrorMessage, setpassErrorMessage] = React.useState("");
	const [loading, setLoading] = useState(false);
	const [onSuccess, setOnSuccess] = useState(false);

	const ErrorMessageEmptyModel = () => {
		setuserErrorMessage("");
		setpassErrorMessage("");
	};
	const context = useContext(LocalStorageContext);

	useEffect(() => {
		localStorage.clear();
	}, []);

	const CheckNull = (value: any) => {
		if (value === "" || value === undefined || value === null) {
			return true;
		}
		return false;
	};

	const isValidate = (values: any) => {
		let formIsValid = true;
		ErrorMessageEmptyModel();
		if (!validEmail.test(values.userName)) {
			setuserErrorMessage("Please enter valid username");
			formIsValid = false;
		}
		if (CheckNull(values.userName)) {
			setuserErrorMessage("Please enter username");
			formIsValid = false;
		}

		return formIsValid;
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
		setState({
			user: {
				...state.user,
				[event.target.name]: event.target.value
			}
		});
	};

	// form handling
	const handleSubmit = (): void => {
		setLoading(true);
		if (isValidate(state.user)) {
			SetPasswordService.forgotPassword(state.user.userName)
				.then((response: any) => {
					setTimeout(() => {
						setOnSuccess(true);
					}, 500);
					setLoading(false);
					Logindata(response, navigate);
					context.updateLogoSrc(response.data.logoURL);
					context.updateStatus(response.data.onboardingStatus);
					context.updateStepFlag(response.data.stepFlag);
					context.updateFacilitator(response.data.isfacilitator);
					context.updateRole(response.data.partnerRole);
				})
				.catch((error) => {
					setLoading(false);
					setOnSuccess(false);
				});
		} else {
			setLoading(false);
		}
	};

	const onHideClick = () => {
		Logout(navigate);
	};

	return (
		<>
			<div className={styles.pageContainer}>
				{/* Hero Section - visible on larger screens */}
				<AuthHero
					mainTitle={invoiceRegisterHeroContent.mainTitle}
					instantly={invoiceRegisterHeroContent.instantly}
					subtitle={invoiceRegisterHeroContent.subtitle}
					benefits={invoiceRegisterHeroContent.benefits}
					logoAlt={invoiceRegisterHeroContent.logoAlt}
				/>
				<div className={styles.formSection}>
					<div className={styles.formWrapper}>
						<div className={styles.formHeader}>
							<Text strong className={styles.freeText}>
								Forgot Password ?
							</Text>
							<Title level={2} className={styles.formTitle}>
								Access the instant payment network
							</Title>
						</div>
						<form>
							<div className={styles.section}>
								<p className={styles.label}>
									{" "}
									<span className="text-danger">*</span> Username
								</p>
								<Input
									id="exampleInputEmail1"
									name="userName"
									type="email"
									className={styles.inputField}
									aria-describedby="emailHelp"
									placeholder="Enter username"
									onChange={handleChange}
									value={state.user.userName}
								/>
								<span className={styles.errorMsg}>{userErrorMessage || ""}</span>
							</div>
							<Button type="primary" block size="large" loading={loading} className={styles.submitButton} onClick={handleSubmit}>
								{loading ? "Processing..." : "Submit"}
							</Button>
						</form>
						<div className={styles.terms}>
							<Link to="/login" className={styles.link}>
								Sign in to discover a world of global instant payments!
							</Link>
						</div>
						<div className="mt-5">
							<SocialFollow />
						</div>
					</div>
				</div>
			</div>
			<Modal open={onSuccess} onCancel={onHideClick} footer={null} centered width={400}>
				<div style={{ textAlign: "center", padding: "20px 10px" }}>
					<img src={RegisterSuccess} alt="success" style={{ width: 50, marginBottom: 16 }} />
					<Title level={4}>Check your email</Title>

					<Text type="secondary">
						Please click on the link that has just been sent to your email account to verify your email and continue to complete the
						process.
					</Text>

					<div style={{ marginTop: 24 }}>
						<Button type="primary" block onClick={() => Logout(navigate)} className={styles.submitButton}>
							OK
						</Button>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default ForgotPassword;
